document.addEventListener("DOMContentLoaded", function(event) {  
  // Select all documents with the class 'document-entry__pinned'
  const pinnedDocuments = Array.from(document.querySelectorAll('.document-entry__pinned'));
  
  // Reverse the order of the pinned documents
  pinnedDocuments.reverse();
  
  // Loop over each pinned element
  pinnedDocuments.forEach(pinned => {
    // Find the parent element with the class 'documents'
    const parent = pinned.closest('.documents');
    
    // Move the pinned element to the start of the parent
    if (parent) {
      parent.prepend(pinned);
    }
  });
});
